exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".examination-overview{font-size:16px !important}.examination-overview-key{color:white;opacity:.5}.examination-overview-email{margin-right:0.5rem}.examination-overview-email:not(:last-child){border-right:solid 1px #ffffff57;padding-right:0.5rem}\n", ""]);

// exports
